import * as Sentry from "@sentry/react";

enum LogLevel {
  INFO = "INFO",
  WARN = "WARN",
  ERROR = "ERROR",
  DEBUG = "DEBUG",
}

interface LogArguments {
  key: string;
  value: number | string | boolean | object | null | undefined;
}

export const logger = {
  info: (message: string, ...args: LogArguments[]) => {
    console.log(`[${LogLevel.INFO}] ${message}`, ...args);
    Sentry.captureMessage(message, {
      level: "info",
      extra: Object.fromEntries(args.map((arg) => [arg.key, arg.value])),
    });
  },
  warn: (message: string, ...args: LogArguments[]) => {
    console.warn(`[${LogLevel.WARN}] ${message}`, ...args);
    Sentry.captureMessage(message, {
      level: "warning",
      extra: Object.fromEntries(args.map((arg) => [arg.key, arg.value])),
    });
  },
  error: (message: string, error?: Error, ...args: LogArguments[]) => {
    console.error(
      `[${LogLevel.ERROR}] ${message}`,
      error?.message || "",
      ...args,
    );

    if (error) {
      Sentry.captureException(error, {
        extra: {
          message,
          ...Object.fromEntries(args.map((arg) => [arg.key, arg.value])),
        },
      });
    } else {
      Sentry.captureMessage(message, {
        level: "error",
        extra: Object.fromEntries(args.map((arg) => [arg.key, arg.value])),
      });
    }
  },
  debug: (message: string, ...args: LogArguments[]) => {
    if (process.env.NODE_ENV === "development") {
      console.debug(`[${LogLevel.DEBUG}] ${message}`, ...args);
    }
  },
};
